import WRAP from 'WRAP-JS';
import { MAP_ID_FORECAST_REGION } from "../../../store/MapContentsState";
import {
  configForecastRegionDh,
  configForecastRegionLayer
} from "./config/ConfigForecastRegion";

class ForecastRegion {
  static NAME = MAP_ID_FORECAST_REGION;
  dh;
  visible = false;
  layer;

  constructor(isDark) {
    this.isDark = isDark;
    this.layer = new WRAP.Geo.Layer(ForecastRegion.NAME);
    this.layer.setVisible(false);
    this.layer.disableInteraction(true);
  }

  initialize() {
    this.initData();
    this.initLayer()
  }

  initData() {
    this.dh = new WRAP.Data(configForecastRegionDh);
  }

  initLayer() {
    this.layer.configure(this.dh, configForecastRegionLayer);
    this.applyMapColor(null, this.isDark);
  }

  async drawLayer(visible) {
    if (!this.dh) {
      this.initialize();
    }
    this.setVisible(visible);
  }

  setVisible(visible) {
    this.visible = visible;
    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  getLayer() {
    return this.layer;
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    const style = this.isDark ? "dark" : "default";
    this.layer.setStyle(style);
  }
}

export default ForecastRegion;
